export default __webpack_public_path__ + "static/media/profileIcon.82e44145.svg";